import React from "react";

import { CellType } from "../types/types";
import "./BoardCell.css";

interface Props {
  cell: CellType;
}

const BoardCell: React.FC<Props> = ({ cell }) => {
  return (
    <div className={`BoardCell ${cell.className}`}>
      <div className="Sparkle"></div>
    </div>
  );
};

export default BoardCell;
